import { render, staticRenderFns } from "./DetailPico.vue?vue&type=template&id=67606c7e&"
import script from "./DetailPico.vue?vue&type=script&lang=js&"
export * from "./DetailPico.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports